import React from 'react'
import { Box, NoData, RequestError, RowsSkeletonLoader } from '@node-space/ui-components'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { usePaymentCaseContext } from 'hooks/context/usePaymentCaseContext'
import { usePaymentCaseEmailsQuery } from 'hooks/queries/usePaymentCaseEmailsQuery'
import { PaymentCaseEmail } from './PaymentCaseEmail'
import { PaymentCaseError } from './PaymentCaseError'

export const PaymentCaseEmails = () => {
  const { paymentCaseId } = usePaymentCaseContext()

  const {
    data: { emails: paymentCaseEmails } = {},
    isPending,
    isError,
  } = usePaymentCaseEmailsQuery(paymentCaseId)

  return (
    <Box>
      {isPending && <RowsSkeletonLoader rows={MIN_PAGINATION_SIZE} />}
      <Box paddingX={20} flex centerChildren>
        {isError && !isPending && <RequestError description={<PaymentCaseError />} />}

        {!isPending && !isError && !!paymentCaseEmails?.length && (
          <Box flex gapY={24} className="flex-col-reverse">
            {paymentCaseEmails?.map((paymentCaseEmail, paymentCaseEmailIndex) => (
              <PaymentCaseEmail key={paymentCaseEmailIndex} paymentCaseEmail={paymentCaseEmail} />
            ))}
          </Box>
        )}

        {!isPending && !isError && !paymentCaseEmails?.length && (
          <NoData dataName="emails regarding your case" />
        )}
      </Box>
    </Box>
  )
}
